import { StateCreator } from 'zustand';

export type DownloadCsvFileByIdState = {
    // Define the type for the state that holds progress and isDownloading for each fileId
    downloads: Record<string | number, { progress: number; isDownloading: boolean }>;
    // Method to set progress and isDownloading for a specific fileId
    setDownloadStatus: (fileId: string | number, progress: number, isDownloading: boolean) => void;

    // Method to get the current status (progress and isDownloading) for a specific fileId
    getDownloadStatus: (fileId: string | number) => { progress: number; isDownloading: boolean } | undefined;
};

export interface DownloadCsvFileByIdSlice {
    downloads: Record<string | number, { progress: number; isDownloading: boolean }>;
    setDownloadStatus: (fileId: string | number, progress: number, isDownloading: boolean) => void;
    getDownloadStatus: (fileId: string | number) => { progress: number; isDownloading: boolean } | undefined;
}
export const createDownloadCsvFileByIdSlice: StateCreator<
    DownloadCsvFileByIdSlice,
    [],
    [],
    DownloadCsvFileByIdSlice
> = (set, get) => ({
    downloads: {}, // Initialize an empty object for downloads state
    // Set the download status (progress and isDownloading) for a specific fileId
    setDownloadStatus: (fileId: string | number, progress: number, isDownloading: boolean) => {
        set((state) => ({
            downloads: {
                ...state.downloads,
                [fileId]: { progress, isDownloading }
            }
        }));
    },

    // Get the current download status for a specific fileId
    getDownloadStatus: (fileId) => {
        return get().downloads[fileId];
    }
});
